import { Banner, Text } from '@vkontakte/vkui';

export function FlowPreviewBanner() {
  return (
    <Banner
      mode="tint"
      before={null}
      title="Режим проверки"
      subtitle={
        <Text style={{ fontSize: 13 }}>
          Повтор пути участника. Данные админа и онбординг в системе не меняются.
        </Text>
      }
    />
  );
}
